import { Button } from "@freightsimple/ui-core/Controls/Button";
import { Row } from "@freightsimple/ui-core/ComponentLayout/Row";
import { Stack } from "@freightsimple/ui-core/ComponentLayout/Stack";
import { T } from "@freightsimple/ui-core/Typography/T";

interface BookShipmentQuotesCopyProps {
  onModify: () => void;
  onRestart: () => void;
  manualQuotingOpen: boolean;
}

export function BookShipmentQuotesCopy(props: BookShipmentQuotesCopyProps) {
  const { onRestart, onModify, manualQuotingOpen } = props;

  return (
    <Stack gap={2} align="center">
      {manualQuotingOpen && (
        <T size="base" color="secondary">
          We're working on more quotes for this shipment. We will notify you
          about new quotes by email. You can also select one of the quotes below
          to book
        </T>
      )}
      {!manualQuotingOpen && (
        <T size="base" color="secondary">
          Please review the quotes and select the one you would like to book.
        </T>
      )}
      <Stack gap={0} align="center">
        <T size="base" color="secondary">
          If you&apos;re not quite ready to book now, you can find these quotes
          saved on in the 'Recent Quotes' tab.
        </T>
        <T size="base" color="secondary">
          Keep in mind that if the shipment differs in any way from the details
          entered, these quotes may not be valid.
        </T>
      </Stack>
      {/* Each link wraps as a whole on narrow screens — without nowrap the
       * words inside a link wrap instead, splitting the label oddly.
       * inheritFont at 18px/semibold reproduces the legacy Cargo link+large
       * look instead of the ui-core link default (12px). */}
      <Row gap={4} wrap justify="center">
        <T size="lg" weight="semibold" nowrap>
          <Button size="link" inheritFont onClick={onModify}>
            Modify Details
          </Button>
        </T>
        <T size="lg" weight="semibold" nowrap>
          <Button size="link" inheritFont onClick={onRestart}>
            Get Quotes for a Different Shipment
          </Button>
        </T>
      </Row>
    </Stack>
  );
}
